import api from 'api'

const prefix = process.env.REACT_APP_API_PREFIX
const url = process.env.REACT_APP_API_URL || ''

export const postDocumentPhotos = async (data) => {
  const result = await api.post(`${url}${prefix}/document-photos/`, data)
  if (result) return result.data
}
